module.exports = __webpack_public_path__ + "static/take-track-registrations-5a5f003e32c92406d170106415497af9.png";